import * as React from 'react';
import { App } from './App';

export const Root = () => {
  return <App />;
};

export default Root;
